import CustomElement from '../core/custom.js'
import Emitter from '../core/emitter.js'

const LOCALSTORAGE_KEY = 'notifications-blacklist'

export const NotificationSimpleClass = class extends CustomElement {
  _connected = false

  constructor() {
    super()
    this.events = {
      'click .js-notification-close': ['onClose', { capture: true }],
      'mousedown .js-notification': 'startDrag',
      'touchstart .js-notification': 'startDrag',
      'mousemove .js-notification': 'onDrag',
      'touchmove .js-notification': 'onDrag',
      'mouseup .js-notification': 'stopDrag',
      'touchend .js-notification': 'stopDrag',
      'mouseleave .js-notification': 'stopDrag'
    }
  }

  connectedCallback() {
    super.connectedCallback()

    if (!this._connected) {
      !this.blacklisted &&
        Emitter.emit('notification:stack', {
          notification: this,
          order: this.dataset.order || 0
        })
      this._connected = true
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback()
  }

  startDrag(e) {
    this.dragging = true
    this.startX = e.screenX || e.changedTouches[0].pageX
  }

  onDrag(e) {
    if (this.dragging) {
      this.classList.add('transition-none')
      const posX = e.screenX || e.changedTouches[0].pageX
      const dx = posX - this.startX
      if (dx < 0) return
      this.cX = dx
      this.transform()
    }
  }

  stopDrag(e) {
    e.stopPropagation()

    if (!this.dragging) return
    this.classList.remove('transition-none')

    this.dragging = false

    const goAway = this.cX > this.width * 0.5

    if (goAway) {
      this.cX = this.width * 1.5
      setTimeout(this.close.bind(this), 200)
    } else {
      this.cX = 0
    }

    this.transform()
  }

  transform() {
    this.style.transform = this.cX ? `translate3d(${this.cX}px,0,0)` : ''
  }

  show() {
    if (this.shown) return

    this.shown = true
    this.style.maxHeight = `${this.scrollHeight}px`
    this.classList.add('is-shown')
    this.width = this.clientWidth
  }

  close() {
    if (!this.shown) return

    this.ontransitionend = ({ target }) => {
      // prevent child transition triggering earlier than element's transition
      if (target !== this) return
      Emitter.emit('notification-close', this)
      this.remove()
    }

    this.style.maxHeight = ''
    this.classList.remove('is-shown')

    this.blacklist()
  }

  blacklist() {
    const { id } = this.dataset
    if (id) {
      this.blacklistStorage = id
    }
  }

  onClose(e) {
    this.close()
  }

  get blacklisted() {
    const { id } = this.dataset
    if (!id) return false
    return new Set(this.blacklistStorage).has(id)
  }

  get blacklistStorage() {
    return JSON.parse(localStorage.getItem(LOCALSTORAGE_KEY) || '[]')
  }

  set blacklistStorage(id) {
    localStorage.setItem(
      LOCALSTORAGE_KEY,
      JSON.stringify(Array.from(new Set([...this.blacklistStorage, id])))
    )
  }
}

export default window.customElements.define(
  'notification-simple',
  NotificationSimpleClass
)
